export type UserType = 'sme' | 'financial_institution';

/**
 * Variant d'opération d'une entité. Orthogonal à UserType.
 * Une coopérative reste `userType='sme'` + `variant='cooperative'` côté backend,
 * une AVEC (épargne et crédit villageois) `variant='avec'`.
 * Le variant détermine :
 *   - le pricing affiché (carte coopérative, 5 USD/coopérant/mois)
 *   - le vocabulaire UI (cf. useEntityVocabulary)
 */
export type EntityVariant = 'standard' | 'cooperative' | 'avec';

export const ENTITY_VARIANTS: readonly EntityVariant[] = ['standard', 'cooperative', 'avec'];

/** Valeur connue ou null : une valeur inconnue ne doit jamais devenir une PME en silence. */
export function parseEntityVariant(value: unknown): EntityVariant | null {
  return typeof value === 'string' && (ENTITY_VARIANTS as readonly string[]).includes(value)
    ? (value as EntityVariant)
    : null;
}

export interface AppConfig {
  clientId: string;
  audience: string;
  domain: string;
  logoutRedirect: string;
}

export interface TokenResponse {
  access_token: string;
  refresh_token?: string;
  id_token?: string;
  expires_in: number;
}